export const utcToLocal = (utcDate: string): string => {
  // Validate input date.
  if (!utcDate) {
    return "";
  }

  try {
    // Create a Date object from the UTC string.
    const date = new Date(utcDate);

    // Validate the parsed date.
    if (isNaN(date.getTime())) {
      return "";
    }

    // Convert to local time and format.
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  } catch (error) {
    console.error("Erreur lors de la conversion de date:", error);
    return "";
  }
};
